// PricingHero.js
import React from 'react';
import { motion } from 'framer-motion';

const PricingHero = () => {
  return (
    <section className="relative py-24 md:py-32 bg-surface overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Tag */}
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block bg-white text-secondary text-sm font-light px-6 py-2 rounded-md mb-6"
          >
            Pricing
          </motion.span>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-6xl font-semibold text-primary mb-6 leading-tight"
          >
            Clear Fees for Serious Guidance
          </motion.h1>

          {/* Subtext */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-gray-600 font-light leading-relaxed max-w-3xl mx-auto mb-8"
          >
            What Ivipass charges reflects the work involved: the consultation, the coordination with institutions or employers, and the preparation behind an application. You will see the full cost, and what it buys, before agreeing to anything.
          </motion.p>

          {/* Key Statement */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-base md:text-lg text-primary font-normal"
          >
            Nothing we charge depends on an outcome, and we never handle tuition or wages.
          </motion.p>

          {/* Decorative Elements */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-12 flex justify-center gap-2"
          >
            <div className="w-20 h-1 bg-primary/20 rounded-full"></div>
            <div className="w-20 h-1 bg-primary/40 rounded-full"></div>
            <div className="w-20 h-1 bg-primary/20 rounded-full"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PricingHero;
